import {FileUploadHandler} from "../govbr-ds/input-fileupload/input-fileupload.component";
import {UploadedFile} from "../../../model/data/uploaded-file";

export class CustomFileUploadHandler implements FileUploadHandler {
    getMeta(file: UploadedFile): { filename: string; size?: number; } {
        return {
            filename: file.original_filename,
            size: file.size,
        };
    }

}
